import axios from "axios";
import config from "../config";

export const sendGeneric = async (mail) => {
    const response = await axios.post(`${config.API_BASE_URL}/mail/send`, mail);
    if (response != null) {
        return response.data;
    }
    return null;
}